import { render, staticRenderFns } from "./writeXa.vue?vue&type=template&id=b3bda6d6&scoped=true&"
import script from "./writeXa.vue?vue&type=script&lang=js&"
export * from "./writeXa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bda6d6",
  null
  
)

export default component.exports